export const tiers = [
  {
    name: 'Pay Per Horse',
    title: 'Horse Management',
    subheader: 'For smaller teams',
    priceMonthly: '$2.20',
    priceAnnual: '$1.98',
    priceAnnualTotal: '$23.76',
    description: [
      'Pay for the horses you manage, up to 50',
      '4 staff accounts, including yours',
      'Horse and record management',
      'Task planning and operations',
      'Digital Barn Board',
      'Calendar management and scheduling',
    ],
    buttonText: 'Start Free Trial',
    buttonVariant: 'outlined',
    selectPlan: (billing) => (billing === 'monthly'
      ? env.stripe_basic_monthly_plan
      : env.stripe_basic_annual_plan),
  },
  {
    name: 'Questri Pro',
    title: 'Professional - Barn Management',
    subheader: 'Recommended',
    priceMonthly: '$199',
    priceAnnual: '$179',
    priceAnnualTotal: '$2,149',
    description: [
      'All Pay Per Horse features',
      '100 horses included',
      'Unlimited staff accounts',
      'Client access through the mobile app',
      'Team chat',
      'Announcements and activity feed',
      'Onboarding, setup, and priority support',
    ],
    buttonText: 'Start Free Trial',
    buttonVariant: 'contained',
    selectPlan: (billing) => (billing === 'monthly'
      ? env.stripe_barn_management_monthly_plan
      : env.stripe_barn_management_annual_plan),
  },
];
